import Utils = require("./utils");
import geo = require("./utils/geo");
import Mediator = require("./mediator");
import AgencyMaps = require("./services/agencymaps");
import Templates = require("./models/defaults");
import Portal = require("portal-gis");
import _ = require("underscore");
import deepExtend = require("./utils/deep-extend");
import globals = require("../globals");
import $ = require("jquery");
import * as resx from "./i18n/common";

// models
import Model = require("./models/base-model");

// collections
import Collection = require("./collections/base-collection");
import SymbologyCollection = require("./collections/symbology-collection");
import LayerCollection = require("./collections/layer-collection");
import FeatureCollection = require("./collections/feature-collection");
import BookmarkCollection = require("./collections/bookmark-collection");

// apps
import RhythmGIS = require("./applications/rhythm-gis-app");
import Controller = require("./controls/controller");
import CommandController = require("./controls/base/command-controller");

const log = Utils.log;

if (globals.proxy) {

    let proxy = url => `${globals.proxy}${encodeURI(url)}`;

    // send cookies!
    $.ajaxPrefilter(function (options, originalOptions, jqXHR) {
        options.xhrFields = {
            withCredentials: true
        };
        options.crossDomain = true;
        if (options.proxy) {
            options.url = proxy(options.url);
            options.proxy = false; // structure["*"] has two items???
        }
    });
}

var serviceInfo = {
    endpoint: globals.services,
    stub: globals.stub === "1",
    auth: () => {
        return {
            Username: "[username]",
            password: "[password]"
        };
    }
}

// NICETOHAVE
// limit to boolean values
class CivicsConfig {
    config = {
        map: {
            enabled: false,
            options: {
                autosave: false,
                // these should be identical to save/options
                persistextent: false,
                persistsearchinput: false, // A-0475
                persistsearchoutput: false,
                persistpoi: false,
                persistmeasurementsettings: false,
                persistdrawingsettings: false,
                persistselectedbookmark: false,
                persistelectedlayers: false,
                persistselectedbasemap: false,
            },
            toolbar: {
                enabled: false,
                controls: {
                    pan: false, // A-0030
                    zoomin: false, // A-0040
                    zoomout: false, // A-0050
                    mylocation: false, // A-0060
                    print: false, // A-0610
                    // A-0630 requires saving the markers with the map (perhaps?)
                    save: {
                        enabled: false, // A-0620
                        // A-0650 redundent
                        options: {
                            persistmarkers: false, // A-0630 (maybe), A-0660
                            persistextent: false, // A-0640
                            persistsearchinput: false, // A-0680
                            persistsearchoutput: false, // A-0680
                            persistdrawings: false, // A-0670
                            persistmeasurementsettings: false, // A-0680
                            persistdrawingsettings: false, // A-0680
                            persistselectedbookmark: false, // A-0680
                            persistselectedlayers: false, // A-0680
                            persistselectedbasemap: false // A-0680
                        },
                        actions: {
                            capturedrawings: false // C-0500
                        }
                    }
                }
            },

            // A-0120 default is specified by convention (1st "basemap" found in CE)
            basemappicker: {
                enabled: false, // A-0105
                sources: {
                    googlestreet: false, // A-0110
                    googlesat: false, // A-0110
                    bingstreet: false, // A-0110
                    bingsat: false, // A-0110
                    osmstreet: false, // A-0110
                    osmsat: false // A-0110
                }
            },

            // A-0350 additional layers are determined by the CE
            // A-0360,A-0370 organization is determined by the CE
            layerpicker: {
                enabled: false, // A-0130, A-0140
                hierarchicalbytype: false, //A-0180,A-0200,A-0210,A-0230,A-0250,A-0270,A-0290,A-0310
                hierarchicalbystatus: false,
                // A-0420 is redundent
                datefilterenabled: false, // A-0430
                statusfilterenabled: false, // A-0440, A-0450 & A-0460 are specified in CE ("inprogress", "closed")
                typefilterenabled: false, // A-0470 other filtering is specified in CE
                multilayerfilteroptionenabled: false, // A-0470
                // A-0475 defaults are provided via CE, see persistsearchinput
                sources: {
                    address: false, // A-0160
                    parcel: false, // A-0170
                    servicerequest: false, // A-0190
                    planningapplication: false, // A-0210
                    projectapplication: false, // A-0220
                    buildingapplication: false, // A-0240
                    useapplication: false, // A-0260
                    case: false, // A-0280
                    businesslicense: false, // A-0300
                    tradelicense: false, // A-0320
                    workorders: false // A-0340
                }
            },
            legend: {
                enabled: false // A-0380 (describes the markers/features on the map)
            },
            // A-0390 extent provided in the CE
            // A-0410 the actual bookmarks are defined in the CE
            bookmarks: {
                enabled: false, //  A-0400
                options: {
                    add: false, // user can create bookmarks
                    remove: false, // user can remove bookmarks
                    currentlocationasbookmark: false, // add 'current location' as a bookmark option
                    initextentasbookmark: false, // add 'initial extent' as bookmark option
                    fullextentasbookmark: false // add 'full extent' as bookmark option
                }
            },
            locationsearch: {
                enabled: false, // A-0480, A-0490
                sources: {
                    google: false,  // A-0510
                    address: false, // A-0510 (req)
                    parcel: false, // A-0500 (req)
                    poi: false, // A-0510 (req)
                    bookmarks: false, // A-0510
                    drawings: false, // A-0510
                    operationallayers: false // A-0510
                },
                options: {
                    locatorselector: false // false to search all otherwise a combo appears to select a single source
                }
            },
            drawings: {
                enabled: false, // A-0520
                options: {
                    singlepoint: false, // A-0530
                    polypoint: false, // A-0540
                    polyline: false, // A-0550
                    polygon: false, // A-0560
                    markers: false, // singlepoint but with markers
                    clear: false, // A-0570
                    mydrawings: {
                        enabled: false,
                        options: {
                            add: false,
                            remove: false
                        }
                    }
                },
                actions: {
                    converttopoi: false // remove? option to convert to POI and persist in a common POI repository
                }
            },
            measurements: {
                enabled: false, // A-0580
                options: {
                    linear: false, // A-0590
                    area: false // A-0600
                }
            },
            share: {
                // A-0690: will not implement sharing (should be an application wide solution)
            },
            // this is the tool that searches within a selected region
            // A-0790 additional sources are provided by the CE
            geosearch: {
                enabled: false, // A-0730
                options: {
                    showlocationinfo: false, // A-0750
                    geobox: false, // search by box
                    geopolygon: false, // search by poly
                    geopoint: false, // search by click + buffer
                    geopolyline: false, // search by line + buffer
                    disableautobuffer: false, // increases the search area
                    showresultsingrid: false, // 
                    showresultsonmap: false,
                    uselayerpickersources: false,
                    uselocationsearchsources: false,
                    usebasemappickersources: false // these are probably not searchable anyway
                },
                sources: {
                    address: false, // A-0740, A-0810, A-1110
                    parcel: false, // A-0760 (A-0770 associated addresses must be configured in the parcel query or part of grid logic?)
                    servicerequest: false, // A-0790
                    planningapplication: false, // A-0790
                    projectapplication: false, // A-0790
                    buildingapplication: false, // A-0790
                    useapplication: false, // A-0790
                    case: false, // A-0790
                    businesslicense: false, // A-0790
                    tradelicense: false // A-0790
                },
                // A-0870,A-0930,A-0940 API provides notification when a source is selected
                // A-0950 additional commands provided in CE
                actions: {
                    capturesource: false, // A-0830, A-0890
                    capturegeometry: false, // A-0880 (closest thing we have to an "image")
                    capturemapextent: false // A-0820, A-0840, A-0850, A-0860, A-0900, A-0910, A-0920
                }
            },
            featureselection: {
                enabled: false, // A-0960
                options: {
                    showinfowindow: false, // A-0970
                    showcontextcommands: false, // A-0990
                    showactioncommands: false, // A-0990
                    showpointcommands: false, // A-0990
                    autopan: false, // A-0990
                    autozoom: false // A-0990
                },
                // A-1000 redundent
                // A-1070,A-1080 API provides selection notification
                // A-1090 additional commands provided in CE
                actions: {
                    capturesource: false, // A-1010
                    capturegeometry: false, // A-1030 (closest thing we have to an "image")
                    capturemapextent: false // A-1040, A-1050, A-1060
                }
            },
            generalsettings: {
                // A-1140 through A-1220 are outside the scope of macro-configuration
            }
        }
    }
}

// TODO
function asConfig(config: CivicsConfig) {
    return <Portal.MapApplicationElement>{};
}

// not sure this was a good idea...pushes config all the way from the top to the bottom!  Could have unexpected consequences.
// currently only pushing one level deep so more intuitive but why would a command inherit it's controls options?
// only makes sense for nested layers
function extendOptions(config: { Options?: Portal.OptionsElement }, items: Array<{ Options?: Portal.OptionsElement }>, todo = true) {
    items && items.forEach(subItem => {
        // identify parent
        //Utils.extend(subItem, { parent: config });
        if (!config.Options.Values.length) return;
        if (todo) return;

        // it is sometimes convenient to call this before setting defaults so make sure Options exists
        if (!subItem.Options) subItem.Options = {
            Values: []
        }

        // child options inherit parent options
        let childHash = Utils.asDictionary(subItem.Options.Values);
        config.Options.Values.forEach(v => {
            if (typeof childHash[v.id] === "undefined") {
                subItem.Options.Values.push({
                    id: v.id,
                    value: v.value
                });
            }
        });
    });
}

function deepTrace(a: any, b: any) {
    let trace = <Array<{
        target: Object;
        key: string;
        value: any;
        was: any;
    }>>[];
    a && b && deepExtend(a, b, trace);
    return trace;
}

interface IController {
    configuration: Portal.ControlLeaf;
    controllers: Rhythm.GIS.Dictionary<Controller>;
    controls: Rhythm.GIS.Dictionary<Portal.ControlLeaf>;
    commands: Rhythm.GIS.Dictionary<Portal.CommandLeaf>;
    events: Rhythm.GIS.Dictionary<Portal.EventsLeaf>;
}

// this is the programmatic point-of-contact for the map control
class API {

    static about = `
The programmatic point-of-contact with the map control instantiated by [liferay-runner](#app/liferay-runner) and facilitated through the [mediator](#app/mediator).

The _create_ method bootstraps the maplet environment
and passes control to an _applications/rhythm-gis-app_ instance, which has access
to this API as well as the underlying configuration.

If no configuration is provided create() queries the rest service for the 'base' configuration.  

Once the configuration arrives from the configuration service:
1. The API() is created and initialized with the configuration.
1. A controller is assigned to the API.  This is an application controller and is implemented in ./applications/rhythm-gis-app.
1. The api.run() waits for the controller to signal it is "ready-to-start" before calling controller.start().  When the controller signals it is "running" the api.run() callback resolves.
 

But what does the application controller do?
1. It is a Marionette application and it listens for "view" events to register those views with the one and only application view (AppView).  Although the AppView is about to be created, it hasn't yet.  The "view" handler defers to the mediator.appView to provide it.  Once it does any past and future "view" is managed here.
1. Meanwhile, the AppView template starts loading.  Once it finishes the AppView is created and the mediator notified, and indirectly, the "view" handler.
1. The AppView renders inside the "region" of application and the app signals it is "ready-to-start".  Recall the api calls application.start(), which triggers "start", which invokes createMapView().  It also signals the application is "running", which is true, although the map has yet to load!
1. createMapView() creates a view controller and then calls createView on that controller.  In this case, the controller is ./controls/map and the only option forwarded is the "region".  It uses the "region" defined under the Map options in configuration or defaults to "maplet-region".
1. The controller uses ./views/MapView and there is no way of changing this.
1. The ./application/rhythm-gis-app has hard-coded configuration for the map controller, setting only the "region".  See createMapView().
1. The map controller sets up event forwarding from the mapView based on applet-level events.
1. The controller tells the mediator that "mapView" is available. 
1. The meditor tells the controller appView is available so it renders the mapView within an appView region ("maplet-region").

| API Methods    | Description |
|:-------------- |:----------- |
| merge          | Merges a configuration into this application instance |

`;

    static options = {
    }

    public configuration: Portal.MapApplicationElement;
    public mediator: Mediator;
    private eventHandlers: Rhythm.GIS.Dictionary<(args: any) => void>;

    static create(config?: Portal.MapApplicationElement) {
        var whenApp = $.Deferred<API>();

        if (!config) {
            log("use base configuration");
            config = {
                parentId: "base"
            }
        } else {
            config = Utils.deep(config);
        }

        // api.config === config
        let api = new API(config);

        let whenConfig = $.Deferred();

        /** 
        wait for the signal that the api has loaded all external data stores 
        */
        Utils.once(api.mediator.model, "api", () => {
            if (config.parentId) {
                api.getAppInfo(Utils.split(config.parentId)).done(parentInfo => {
                    // merge the current configuration into the parent configuration
                    // because the parent configuration has lower precedence
                    // but we don't want to lose the original config objects
                    deepExtend(config, deepExtend(parentInfo, config));
                    whenConfig.resolve();
                });
            } else {
                whenConfig.resolve();
            }
        });

        whenConfig.done(() => {
            log("configuration loaded");
            api.merge(config).done(() => {
                log("configuration merged");
                api.controller = new RhythmGIS(api, config);
                log("application created");
                api.run().done(() => {
                    log("application running");
                    whenApp.resolve(api);
                });
            });
        });

        return whenApp;
    }

    controller: RhythmGIS;

    // model collections
    bookmarks: BookmarkCollection;
    features: FeatureCollection;
    layers: LayerCollection;
    symbology: SymbologyCollection;

    // TODO: make (parts of) this a controller
    controllers: Rhythm.GIS.Dictionary<Controller>;
    controls: Rhythm.GIS.Dictionary<Portal.ControlLeaf>;
    commands: Rhythm.GIS.Dictionary<Portal.CommandLeaf>;
    events: Rhythm.GIS.Dictionary<Portal.EventsLeaf>;

    constructor(config?: Portal.MapApplicationElement) {
        {
            this.controllers = {};
            this.controls = {};
            this.commands = {};
            this.events = {};
            this.configuration = this.defaults(config || {});
            log("defaults assigned to application configuration");
        }

        {
            this.mediator = new Mediator();
            log("mediator created");
        }

        this.eventHandlers = {};

        {
            let options = Utils.asDictionary(this.configuration.Options.Values);
            let optionMappings = {
                "feature-model": "features",
                "bookmark-model": "bookmarks",
                "layer-model": "layers",
                "symbology-model": "symbology",
            };
            let keys = _.keys(optionMappings).filter(key => !!options[key]);
            let mids = keys.map(key => ({ mid: options[key] }));

            Utils.loadModules(mids).done(models => {
                keys.forEach(key => this[optionMappings[key]] = models.factory[options[key]]);

                // app data
                this.features = this.features || new FeatureCollection();
                this.bookmarks = this.bookmarks || new BookmarkCollection();
                this.layers = this.layers || new LayerCollection();
                this.symbology = this.symbology || new SymbologyCollection();
                log("application stores initialized");

                /** 
                ad-hoc storage, event history (see Utils.once, fires once the value is available) 
                also signals the api is ready to use
                */
                this.mediator.model.set({ api: this });
                log("api published to mediator");
            });

        }
    }

    /**
     * destroys the outer view
     * TODO: lots of dangling callback to deal with
     */
    destroy() {
        this.mediator.destroy();
        this.controller.destroy();
        // eventHandlers is unused, what else can be cleaned up?
    }

    // set configuration defaults
    defaults(appInfo: Portal.MapApplicationElement) {

        var defaultCommand = (c: Portal.CommandLeaf) => {
            Utils.defaults(c, Templates.commandTemplate);
        }

        var defaultEvent = (c: Portal.EventsLeaf) => {
            Utils.defaults(c, Templates.eventTemplate);
        }

        let cec = (c: Portal.ControlLeaf) => {
            c.Commands.Commands.forEach(defaultCommand);
            extendOptions(c, c.Commands.Commands);

            c.Events.Events.forEach(defaultEvent);
            extendOptions(c, c.Events.Events);

            c.Controls.Controls.forEach(defaultControl);
            extendOptions(c, c.Controls.Controls);
        };

        var defaultControl = (c: Portal.ControlLeaf) => {
            Utils.defaults(c, Templates.controlTemplate);
            cec(c);
        };

        var defaultBookmark = (c: Portal.MapBookmarkLeaf) => {
            Utils.defaults(c, Templates.mapBookmarkTemplate);
        };

        var defaultFeature = (c: Portal.FeatureLeaf) => {
            Utils.defaults(c, Templates.mapFeatureTemplate);

            // HACK03: intrim 'solution', not sure how to preserve nested data
            c.Attributes.Values
                .filter(v => (v.value.length && 0 === v.value.indexOf("{") && v.value.length === 1 + v.value.lastIndexOf("}")))
                .forEach(v => v.value = JSON.parse(v.value));

            cec(c);
        };

        var defaultLayer = (c: Portal.MapLayerLeaf) => {
            Utils.defaults(c, Templates.mapLayerTemplate);
            cec(c);

            c.Features.Features.forEach(defaultFeature);
            extendOptions(c, c.Features.Features);

            if (c.Layers) {
                extendOptions(c, c.Layers.Layers, false);
                c.Layers.Layers.forEach(defaultLayer);
                // provide access to parent so layer model can be updated
                c.Layers.Layers.forEach(l => Utils.extend(l, { parent: c }));
            }
        };

        var defaultIcon = (c: Portal.MapIconConfigElement) => {
            Utils.defaults(c, Templates.iconTemplate);
        };

        var defaultSymbol = (c: Portal.MonikerSymbologyElement) => {
            Utils.defaults(c, Templates.symbolTemplate);
            c.Icons && c.Icons.forEach(defaultIcon);
        };

        var defaultMap = (c: Portal.MapDefinitionElement) => {
            Utils.defaults(c, Templates.mapDefTemplate);

            c.Bookmarks.Bookmarks.forEach(defaultBookmark);
            //extendOptions(c, c.Bookmarks.Bookmarks);

            c.Features.Features.forEach(defaultFeature);
            extendOptions(c, c.Features.Features);

            c.Layers.Layers.forEach(defaultLayer);
            extendOptions(c, c.Layers.Layers);

            c.Symbology.Symbols.forEach(defaultSymbol);
            //extendOptions(c, c.Symbology.Symbols);
        }

        var defaultAppInfo = (c: Portal.MapApplicationElement) => {
            Utils.defaults(c, Templates.appTemplate);

            cec(c);

            defaultMap(c.Map);
        };

        defaultAppInfo(appInfo);

        return appInfo;
    }

    // get app configuration
    getAppInfo(ids: string | string[], mergeOnClient = serviceInfo.stub) {
        log("getting configuration: ", ids);

        var d = $.Deferred<Portal.MapApplicationElement>();

        // get configuration for a single app
        if (typeof ids === "string") {
            let service = new AgencyMaps(serviceInfo);

            service.get(ids).done(appInfo => {
                log("received configuration: ", ids, appInfo.data);
                if (mergeOnClient && appInfo.data.parentId) {
                    this.getAppInfo(Utils.split(appInfo.data.parentId), mergeOnClient).done(parentInfo => {
                        deepExtend(parentInfo, appInfo.data);
                        log("configuration merged: ", ids, parentInfo);
                        d.resolve(parentInfo);
                    });
                } else {
                    d.resolve(appInfo.data);
                }
            });
        } else {
            // get composite configuration
            let result = <Portal.MapApplicationElement>{};

            Utils.when(ids.map(id => this.getAppInfo(id, mergeOnClient))).done(maps => {
                maps.forEach(map => deepExtend(result, map));
                log("multi-configuration merged: ", ids, result);
                d.resolve(result);
            });
        }
        return d;
    }

    run() {
        var controller = this.controller;
        var whenReady = $.Deferred();

        // wait until the application is ready to extent
        controller.on("ready-to-start", () => {
            log("application controller ready-to-start");
            controller.start();
        });

        // wait until the application has started
        controller.on("running", () => {
            log("application controller is running");
            whenReady.resolve();
        });

        return whenReady;
    }

    /** loads, instantiates and registers a command with this controller */
    registerCommands(config: Portal.CommandsElement, controller = <IController>this) {

        return Utils.loadCommandModules(config.Commands.filter(c => !c.disabled)).then(commands => {
            // instantiates each command but only 'startup' commands should 'execute' immediately
            commands.modules.forEach(c => {
                log(`creating command: ${c.id} from ${c.mid}`);
                let command = new (commands.factory[c.mid])(c, this.mediator, {
                    controller: controller
                });
                if (c.type === "startup") command.execute();

                if (controller["commandControllers"]) {
                    let ctlr = <Controller>controller;
                    ctlr.commandControllers[c.id] = new CommandController(ctlr, c, this.mediator);
                }
            });
            return commands.modules;
        });

    }

    registerEvents(config: Portal.EventsElement, controller = <IController>this) {
        var d = $.Deferred<Portal.EventsLeaf[]>();

        Utils.loadEventModules(config.Events).done(events => {

            // hookup event to mediator (similar to an app command)
            events.modules.forEach(event => {
                log(`registering handler: ${event.id} against ${event.mid}`);
                if (events.factory[event.mid].about) {
                    log(`about ${event.mid}: ${events.factory[event.mid].about}`);
                }
                Utils.split(event.name).filter(v => !!v).forEach(eventName => {
                    this.mediator.on(eventName, c => {
                        log("executing handler: ", eventName);
                        Utils.execute(event, this.mediator, c);
                    });
                });
                controller.events[event.id] = event;
            });

            d.resolve(events.modules);
        });

        return d;
    }

    registerControls(config: Portal.ControlsElement, controller = <IController>this) {

        return Utils.loadControllerModules(config.Controls.filter(c => !c.disabled)).then(controls => {

            // instantiates each control and initializes via createView (when possible)
            let controllers = controls.modules.map(c => {
                log(`creating control: ${c.id} from ${c.mid}`);
                let control = <Controller>new (controls.factory[c.mid])(c, this.mediator, {
                    controller: controller
                });
                controller.controllers[c.id] = control;
                return control;
            });

            // do not create the view until the application is loaded
            controllers = controllers.filter(c => !!c["createView"]);
            if (controllers.length) {
                this.mediator.appView(appView => {
                    log("creating views for: ", controllers.map(c => c.configuration.id));
                    controllers.forEach(c => c["createView"]());
                });

            }
            return controls;
        });

    }

    registerViewport(config: Portal.MapViewportLeaf) {
        if (!config.extent) return;
        // TODO: adding/removing/modifying LODs may require completely rebuilding the map, not sure it's important enough to implement
        // TODO: this should set "extent" on mediator model via mediator.stigger (sticky trigger, sets the mediator, invokes trigger)
        // this.mediator.stigger({"extent": extent});       
        this.mediator.mapView(v => v.extent = geo.asExtent(config.extent));
    }

    registerBookmarks(config: Portal.MapBookmarksElement, source = this.bookmarks) {
        config.Bookmarks.forEach(bookmark => source.merge(bookmark));
    }

    registerFeatures(config: Portal.MapFeaturesElement, source = this.features) {
        // add to the feature collection, map will render them on a geometry-appropriate layer
        config.Features.forEach(feature => source.merge(feature));
    }

    registerLayers(config: Portal.MapLayersElement, source = this.layers) {
        // add to the layer collection, map will add on top of existing layers (TODO: support re-ordering)
        config.Layers.forEach(layer => {
            let model = source.merge(layer);
            if (layer.Layers) {
                //let childLayers = this.registerLayers(layer.Layers, new LayerCollection());
                //// TODO: seems very wrong...should not be affecting the config
                //model.get("Layers").Layers = childLayers;
            }
        });
        return source;
    }

    registerSymbology(config: Portal.MapSymbologyElements, source = this.symbology) {
        if (!config) return;
        config.Symbols.forEach(sym => source.merge(sym));
        return source;
    }

    merge(config: Portal.MapApplicationElement) {
        if (!config) return;
        config = this.defaults(config);
        this.mergePackages(config.Packages);
        return this.mergeLocalizations(config.Localizations).then(i18n => {
            this.mergeMap(config.Map);

            // merge the configuration
            this.mergeControls(config.Controls);
            this.mergeEvents(config.Events);
            this.mergeCommands(config.Commands);

            // the configuration is now fully merged, register new events, commands, controls
            return this.updateController(<any>this, config);
        });

    }

    public updateController(controller: Controller, configuration = controller.configuration) {
        log("updating controller: ", configuration.id);
        let d = $.Deferred();

        // update existing child controllers mentioned in the configuration before updating this controller
        Utils.when(configuration.Controls.Controls.filter(cfg => !!this.controllers[cfg.id]).map(cfg => this.updateController(this.controllers[cfg.id], cfg))).then(() => {

            // determine what was newly added to this controller, 
            // gets the real configuration not what was merged in (this.configuration not the parameter)
            let newEvents = controller.configuration.Events.Events.filter(c => !this.mediator.extend(c).controller);
            let newCommands = controller.configuration.Commands.Commands.filter(c => !this.mediator.extend(c).controller);
            let newControls = controller.configuration.Controls.Controls.filter(c => !this.mediator.extend(c).controller);

            // facilitates access to controller from configuration
            newControls.forEach(c => controller.mediator.extend(c, { controller: controller }));
            newEvents.forEach(c => controller.mediator.extend(c, { controller: controller }));
            newCommands.forEach(c => controller.mediator.extend(c, { controller: controller }));

            // load controls
            let controlsReady = Utils.loadControllerModules(newControls.filter(c => !c.disabled));
            // load events
            let eventsReady = Utils.loadEventModules(newEvents.filter(c => !c.disabled));
            // load commands
            let commandsReady = Utils.loadCommandModules(newCommands.filter(c => !c.disabled));

            Utils.when(<any>[controlsReady, eventsReady, commandsReady])
                .fail(() => {
                    // merge already happened...won't roll it back but don't proceed with a partial configuration
                    throw "unable to load at least one control, event or command module";
                })
                .done(() => {

                    // events are registered before commands so startup commands can have handlers
                    controlsReady.then(controlInfo => {
                        log("controls loaded: ", configuration.id, controlInfo.modules.map(c => c.id));

                        // instantiates each child control
                        controller.registerControls({ Controls: controlInfo.modules }).done(() => {

                            // register event handlers with api and self (app.execute runs this event, mediator.trigger fires it)
                            eventsReady.then(eventInfo => {
                                log("events loaded: ", configuration.id, eventInfo.modules.map(c => c.id));
                                controller.registerEvents({ Events: eventInfo.modules });

                                // register commands with api and controller (instantiates each command only after controls and events are registered)
                                commandsReady.then(commandInfo => {
                                    log("commands loaded: ", configuration.id, commandInfo.modules.map(c => c.id));
                                    controller.registerCommands({ Commands: commandInfo.modules });
                                    d.resolve();
                                });
                            });
                        });
                    });
                });
        });
        return d;
    }

    mergePackages(packages: Portal.PackagesElement) {

        if (!packages || !packages.Packages.length) return;

        var p = packages.Packages.map(key => ({
            name: key.id,
            location: key.location || key.id,
            main: key.main || key.id
        }));

        requirejs.config({
            packages: [<any>"main"].concat(p)
        });

    }

    /**
     * The configuration specifies a target mid (e.g. app/i18n/common) and if that target does not exist or is not specified
     * it will default to resx (which really is app/i18n/common)
     * Each of the resources are added to the localization object, which is obtained via the module 'get' method (intoThese)
     * Advantage being we can namespace translations via mid but presently all translations go through Utils.translate which uses app/i18n/common
     */
    mergeLocalizations(localizations: Portal.LocalizationModuleElement) {
        let d = $.Deferred();
        if (!localizations.Resources.length) {
            d.resolve();
            return d;
        }

        let i18n = localizations.Resources;
        let mids = i18n.map(r => r.mid || 'app/i18n/common');

        let doit = (...args: typeof resx[]) => {
            args.forEach((resx, i) => {
                let locale = i18n[i].lang || 'en-US';
                let target = resx(locale);
                i18n[i].Resources.forEach(resource => target[resource.id] = resource.value);
            });
            d.resolve();
        };

        requirejs(mids,
            // require resources
            doit,
            // if config has unknown modules alias them and try again
            err => {
                if (err.requireType === "scripterror") {
                    err.requireModules.forEach(mid => {
                        requirejs.undef(mid);
                        define(mid, () => resx);
                    });

                    requirejs(mids, doit);
                }
            });

        return d;
    }

    mergeMap(config: Portal.MapDefinitionElement) {
        if (!config) return;
        this.mergeSymbology(config.Symbology);
        this.mergeBookmarks(config.Bookmarks);
        this.mergeViewport(config.Viewport);
        this.mergeFeatures(config.Features);
        this.mergeLayers(config.Layers);

    }

    mergeCommands(config: Portal.CommandsElement, controller = <IController>this) {
        if (!config) return;
        deepExtend(controller.configuration.Commands, config);

        // losing ability to detect which ones were newly added
        // views that care will need to track state internally
        // or this could be part of another phase (merge -> apply -> create or update)
        controller.configuration.Commands.Commands
            .filter(c => !controller.commands[c.id])
            .forEach(c => controller.commands[c.id] = c);
    }

    mergeControls(config: Portal.ControlsElement, controller = <IController>this) {
        deepExtend(controller.configuration.Controls, config);

        // losing ability to detect which ones were newly added
        // views that care will need to track state internally
        // or this could be part of another phase (merge -> apply -> create or update)
        controller.configuration.Controls.Controls
            .filter(c => !controller.controls[c.id])
            .forEach(c => controller.controls[c.id] = c);
    }

    mergeEvents(config: Portal.EventsElement, controller = <IController>this) {
        if (!config) return;
        deepExtend(controller.configuration.Events, config);

        // losing ability to detect which ones were newly added
        // views that care will need to track state internally
        // or this could be part of another phase (merge -> apply -> create or update)
        controller.configuration.Events.Events
            .filter(c => !controller.events[c.id])
            .forEach(c => controller.events[c.id] = c);
    }

    mergeBookmarks(config: Portal.MapBookmarksElement) {
        if (!config) return;
        deepExtend(this.configuration.Map.Bookmarks, config);
        this.registerBookmarks(config);
    }

    mergeViewport(config: Portal.MapViewportLeaf) {
        if (!config) return;
        deepExtend(this.configuration.Map.Viewport, config);

        this.mergeLods(config.LODS);

        // replace the configured extent
        if (config.extent)
            this.configuration.Map.Viewport.extent = config.extent;

        this.registerViewport(config);
    }

    mergeLods(config: Portal.ViewportLevelsElement) {
        if (!config) return;
        // TODO: support for LODS
    }

    mergeFeatures(config: Portal.MapFeaturesElement) {
        if (!config) return;
        deepExtend(this.configuration.Map.Features, config);
        this.registerFeatures(config);
    }

    mergeLayers(config: Portal.MapLayersElement) {
        if (!config) return;
        let t = (layer: Portal.MapLayerLeaf) => {
            layer.text = layer.text && Utils.translate(layer.text);
            if (layer.Options && layer.Options.Values) {
                layer.Options.Values.forEach((option, index) => {
                    option.value = option.value && Utils.translate(option.value);
                });
            }
            layer.Layers && layer.Layers.Layers.forEach(t);
        }
        config.Layers.forEach(t);

        deepExtend(this.configuration.Map.Layers, config);
        this.registerLayers(config, this.layers);
    }

    mergeSymbology(config: Portal.MapSymbologyElements) {
        if (!config) return;
        config.Symbols.forEach(symbol => {
            let symbolLabel = symbol.Label && Utils.translate(symbol.Label);
            symbol.Icons.forEach(icon => {
                icon.Label = (icon.Label && Utils.translate(icon.Label)) || symbolLabel;
                icon.zIndex = 1000;
            });
        });

        deepExtend(this.configuration.Map.Symbology, config);
        this.registerSymbology(config);
    }

}

export = API;